export default __webpack_public_path__ + "assets/aeb385a281e8584923d7aafeb3e07dc9.png";